import { useEffect, useState } from "react";
import ContainerModalActions from "../Containers/ContainerModalActions";
import {
  BUTTON_GO_BACK,
  BUTTON_SELECT,
  BUTTON_UPDATE,
  LOADING_INFORMATION,
  MODAL_LEAD_FORMS_LIST_DESCRIPTION,
  MODAL_LEAD_FORMS_LIST_TITLE,
  UPDATING_INFORMATION,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import ModalBasicLayout from "../Modal/ModalBasicLayout";
import Loader from "../Loaders/Loader";
import Box from "@mui/material/Box";
import CachedIcon from "@mui/icons-material/Cached";
import DialogActions from "@mui/material/DialogActions";
import { useDispatchApp } from "../../lib/redux";
import { usePagination } from "../../hooks/usePagination";
import useNearScreen from "../../hooks/useNearScreen";
import { startGetInstantForm } from "../../actions/adsCampaigns";
import { LeadFormsList } from "./LeadFormsList";
import _ from "lodash";
import Button from "../Buttons/Button";
import { LINKEDIN } from "../../utils/constants";

const ModalLeadFormsList = ({
  modalOpen,
  integrationID,
  adAccountID,
  onCloseModal = () => {},
  onCallbackSelect = () => {},
}) => {
  const [leadForms, setLeadForms] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();

  const onGetLeadForms = async () => {
    if (loadLastItem) return;

    const response = await dispatch(
      startGetInstantForm({
        integrationID,
        adAccountID,
        lastKey,
        onChangeLastKey,
        onChangeLoadLastItem,
        platform: LINKEDIN,
      })
    );

    if (response.ok) {
      const data = response.data;

      setLeadForms((prev) => _.uniqBy([...prev, ...data], "id"));
    }

    if (isLoading) setIsLoading(false);

    return response.ok;
  };

  const { lastKey, onChangeLastKey } = usePagination({
    rowsPerPageValue: 10,
    onCallBackNextPage: onGetLeadForms,
  });

  const { fromRef, loadLastItem, onChangeLoadLastItem, isNearScreen } =
    useNearScreen({
      distance: "100px",
    });

  const onUpdateLeadForms = async () => {
    setSelectedItem(null);
    setIsUpdating(true);
    setIsLoading(true);

    const response = await dispatch(
      startGetInstantForm({
        integrationID,
        adAccountID,
        platform: LINKEDIN,
        onChangeLastKey,
        onChangeLoadLastItem,
      })
    );

    if (response.ok) {
      const data = response.data;

      setLeadForms(data);
    }

    setIsLoading(false);
    setIsUpdating(false);

    return response.ok;
  };

  useEffect(() => {
    onGetLeadForms();
    // eslint-disable-next-line
  }, [isNearScreen]);

  const onSendSelectedItem = () => {
    const leadFormSelected = leadForms.find(
      (leadForm) => leadForm.id === selectedItem
    );
    onCallbackSelect(leadFormSelected);
    onCloseModal();
  };

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth={true}
      scroll="paper"
      maxWidth="xs"
      title={t(MODAL_LEAD_FORMS_LIST_TITLE)}
      description={t(MODAL_LEAD_FORMS_LIST_DESCRIPTION)}
    >
      {isLoading && (
        <Loader
          hasMessage={true}
          message={t(isUpdating ? UPDATING_INFORMATION : LOADING_INFORMATION)}
        />
      )}
      {!isLoading && (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "row",
              },
              gap: 1,
              justifyContent: "flex-end",
              width: "100%",
              mb: 2,
            }}
          >
            <Button
              disabled={isLoading}
              color="secondary"
              startIcon={<CachedIcon />}
              onClick={onUpdateLeadForms}
              sx={{
                minWidth: 150,
              }}
            >
              {t(BUTTON_UPDATE)}
            </Button>
          </Box>
          <LeadFormsList
            selectedItem={selectedItem}
            onChangeSelectedItem={setSelectedItem}
            leadForms={leadForms}
            lastItemRef={fromRef}
            loadLastItem={loadLastItem}
          />
        </>
      )}
      <DialogActions
        sx={{
          p: 0,
        }}
      >
        <ContainerModalActions
          hasPadding={true}
          propsSecondaryButton={{
            showButton: true,
            onClick: onCloseModal,
            text: BUTTON_GO_BACK,
          }}
          propsPrimaryButton={{
            showButton: true,
            disabled: !selectedItem,
            text: BUTTON_SELECT,
            type: "submit",
            onClick: onSendSelectedItem,
          }}
        />
      </DialogActions>
    </ModalBasicLayout>
  );
};

export default ModalLeadFormsList;
